import { createFileRoute } from '@tanstack/react-router'
import { CompetitionTrash } from './CompetitionTrash'

export const Route = createFileRoute('/competition_/trash/')({
  component: () => <CompetitionTrash />,
})
